/* featured-variant-filter.js
   Filters Color swatches based on selected Size in the Featured Product (Deal of the week).
   Works with your theme DOM:
   - fieldset[0] = Size
   - fieldset[1] = Color
   - color tiles are <label class="swatch-option ..."> with data-value="Color Name"
*/

(function () {
  if (window.__featuredVariantFilterLoaded) return;
  window.__featuredVariantFilterLoaded = true;

  const norm = (s) =>
    (s || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  function getSectionEls() {
    return Array.from(document.querySelectorAll('[data-featured-variant-filter="true"]'));
  }

  function getVariants(sectionEl) {
    const sc = sectionEl.querySelector(".productVariantsQty");
    if (!sc) return [];
    try {
      const arr = JSON.parse(sc.textContent || "[]");
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function getFieldsets(sectionEl) {
    return Array.from(sectionEl.querySelectorAll("fieldset"));
  }

  function getSelectedSize(sectionEl) {
    const fs = getFieldsets(sectionEl)[0];
    if (!fs) return "";

    // Your theme uses labels + hidden radios OR aria-checked
    const checkedInput = fs.querySelector("input[type='radio']:checked");
    if (checkedInput && checkedInput.value) return checkedInput.value.trim();

    const ariaChecked = fs.querySelector("[aria-checked='true']");
    if (ariaChecked) {
      const dv = ariaChecked.getAttribute("data-value");
      if (dv) return dv.trim();
      const t = ariaChecked.textContent;
      if (t) return t.replace(/\s+/g, " ").trim();
    }

    const selected = fs.querySelector(".is-selected,.selected,[data-selected='true']");
    if (selected) {
      const dv = selected.getAttribute("data-value");
      if (dv) return dv.trim();
      const t = selected.textContent;
      if (t) return t.replace(/\s+/g, " ").trim();
    }

    return "";
  }

  function getColorTiles(sectionEl) {
    const fs = getFieldsets(sectionEl)[1];
    if (!fs) return [];
    // In your theme the tile itself is the label with data-value
    return Array.from(fs.querySelectorAll("label[data-value], button[data-value], button[data-option-value], label[data-option-value]"));
  }

  function getTileValue(tile) {
    return (
      tile.getAttribute("data-value") ||
      tile.getAttribute("data-option-value") ||
      tile.textContent ||
      ""
    )
      .replace(/\s+/g, " ")
      .trim();
  }

  function applyFilter(sectionEl) {
    const variants = getVariants(sectionEl);
    if (!variants.length) return;

    const selectedSize = getSelectedSize(sectionEl);
    if (!selectedSize) return;

    // Build status map for this size: color -> exists + anyAvailable
    const colorStatus = new Map(); // key=norm(color) -> { anyAvailable: bool }
    variants
      .filter((v) => norm(v.option1) === norm(selectedSize))
      .forEach((v) => {
        const c = (v.option2 || "").trim();
        if (!c) return;
        const key = norm(c);
        const prev = colorStatus.get(key) || { anyAvailable: false };
        prev.anyAvailable = prev.anyAvailable || (v.available !== false);
        colorStatus.set(key, prev);
      });

    const tiles = getColorTiles(sectionEl);
    if (!tiles.length) return;

    tiles.forEach((tile) => {
      const val = getTileValue(tile);
      const key = norm(val);
      const info = colorStatus.get(key);

      const existsForSize = !!info;
      const isAvailable = info ? info.anyAvailable : false;

      // Hide if it does NOT exist for this size
      tile.classList.toggle("is-nonexistent", !existsForSize);
      tile.style.display = existsForSize ? "" : "none";

      // OOS only if exists but not available
      tile.classList.toggle("is-oos", existsForSize && !isAvailable);
            // --- Fix "Out of stock" text that stays even when available ---
      // Your theme keeps an element with text "Out of stock" inside the label.
      // We hide it when available, and show it (as block under) only when truly OOS.
      const oosNodes = Array.from(tile.querySelectorAll("*")).filter((el) =>
        norm(el.textContent).includes("out of stock")
      );

      if (existsForSize && isAvailable) {
        oosNodes.forEach((el) => (el.style.display = "none"));
      } else if (existsForSize && !isAvailable) {
        oosNodes.forEach((el) => {
          el.style.display = "block";   // show under the color
          el.style.marginTop = "4px";
        });
      }

      // If theme adds "Out of stock" text by CSS/class, this class toggle is enough.
    });
  }

  function scheduleApply(sectionEl) {
    // Apply after theme has finished updating DOM (important)
    requestAnimationFrame(() => {
      applyFilter(sectionEl);
      requestAnimationFrame(() => applyFilter(sectionEl));
    });
  }

  function bind(sectionEl) {
    // initial
    scheduleApply(sectionEl);

    // Any change/click inside the section can rebuild swatches
    sectionEl.addEventListener("change", () => scheduleApply(sectionEl));
    sectionEl.addEventListener("click", (e) => {
      if (e.target && e.target.closest("fieldset")) scheduleApply(sectionEl);
    });

    // If theme re-renders swatch HTML, re-run filter
    const obs = new MutationObserver(() => scheduleApply(sectionEl));
    obs.observe(sectionEl, { childList: true, subtree: true });
  }

  function init() {
    getSectionEls().forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
})();